import { render } from "./StaffRegister.vue?vue&type=template&id=1d20db91&scoped=true&ts=true"
import script from "./StaffRegister.vue?vue&type=script&lang=ts"
export * from "./StaffRegister.vue?vue&type=script&lang=ts"

import "./StaffRegister.vue?vue&type=style&index=0&id=1d20db91&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d20db91"]])

export default __exports__